//
// Autogenerated by Thrift Compiler (0.7.0-en-11139b3b5cb61e817408c6e84b0e1c258bf6c6ae)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;

  module.exports.Priority = {
    'IMMEDIATE' : 0,
    'SUITABLE' : 1
  };

  module.exports.Placement = {
    'FULLSCREEN' : 0,
    'BANNER' : 1,
    'CARD' : 2
  };

  module.exports.TriggerType = {
    'PASTE' : 0,
    'UNDO' : 1,
    'PICTURE' : 2
  };

  module.exports.Events = Thrift.Struct.define('Events',  {
    1: { alias: 'show', type: Thrift.Type.STRING },
    2: { alias: 'dismiss', type: Thrift.Type.STRING }
  });

  module.exports.Event = Thrift.Struct.define('Event',  {
    1: { alias: 'name', type: Thrift.Type.STRING },
    2: { alias: 'time', type: Thrift.Type.I64 },
    3: { alias: 'messageKey', type: Thrift.Type.STRING }
  });

  module.exports.MessageContent = Thrift.Struct.define('MessageContent',  {
    1: { alias: 'html', type: Thrift.Type.STRING },
    2: { alias: 'version', type: Thrift.Type.I64 }
  });

  module.exports.Trigger = Thrift.Struct.define('Trigger',  {
    1: { alias: 'kind', type: Thrift.Type.I32 },
    2: { alias: 'criteria', type: Thrift.Type.MAP, def: Thrift.Map.define(Thrift.Type.STRING, Thrift.Type.STRING )  }
  });

  module.exports.InAppMessage = Thrift.Struct.define('InAppMessage',  {
    1: { alias: 'key', type: Thrift.Type.STRING },
    2: { alias: 'priority', type: Thrift.Type.I32 },
    3: { alias: 'events', type: Thrift.Type.STRUCT, def: module.exports.Events },
    4: { alias: 'content', type: Thrift.Type.STRUCT, def: module.exports.MessageContent },
    5: { alias: 'placement', type: Thrift.Type.I32 },
    6: { alias: 'trigger', type: Thrift.Type.STRUCT, def: module.exports.Trigger }
  });

  module.exports.InAppMessageIdentifier = Thrift.Struct.define('InAppMessageIdentifier',  {
    1: { alias: 'key', type: Thrift.Type.STRING },
    2: { alias: 'version', type: Thrift.Type.I64 }
  });

  module.exports.MessageResponse = Thrift.Struct.define('MessageResponse',  {
    1: { alias: 'messages', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, module.exports.InAppMessage)  }
  });

  module.exports.MessageRequest = Thrift.Struct.define('MessageRequest',  {
    1: { alias: 'knownMessages', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRUCT, module.exports.InAppMessageIdentifier) },
    2: { alias: 'supportedTriggers', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.I32) },
    3: { alias: 'supportedPlacements', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.I32) },
    4: { alias: 'events', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, module.exports.Event)  },
    5: { alias: 'locale', type: Thrift.Type.STRING },
    6: { alias: 'clientVersion', type: Thrift.Type.STRING }
  });

